import { Box, Container, Typography } from "@mui/material";
import React from "react";
import ErrorImage from "../../../assets/svgs/error.svg";
import COLORS from "../../../constants/Colors";

function ErrorScreen({
  customErrorMsg = null,
  customErrorHeading = null,
  customErrorImage = null,
  imageSize = "400px",
  actionLabel = "Action",
  action = () => {},
}) {
  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Box
        sx={{
          height: imageSize,
          width: imageSize,
          overflow: "hidden",
          backgroundImage: `url(${customErrorImage || ErrorImage})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      />
      <Typography fontSize={"3rem"} fontWeight={700}>
        {customErrorHeading || "Oops!"}
      </Typography>
      <Typography fontSize={"1rem"} fontWeight={400} textAlign={"center"}>
        {customErrorMsg || "Something went wrong. Please try again later."}
      </Typography>
      {!!actionLabel && <Typography
        fontSize={"1rem"}
        fontWeight={400}
        textAlign={"center"}
        sx={{
          mt: "20px",
          cursor: "pointer",
          userSelect: "none",
        }}
        color={COLORS.PRIMARY}
        onClick={action}
      >
        {actionLabel || "Action"}
      </Typography>}
    </Container>
  );
}

export default ErrorScreen;
